
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import ErrorPage from "./pages/ErrorPage";
import NotFound from "./pages/NotFound";
import PrivateRoute from "./routes/PrivateRoute";
import MainLayout from "./layouts/MainLayout";
import RedirectToDashboard from "./routes/RedirectToDashboard";
import Unauthorized from "./pages/Unauthorized";
import RolePermissionPage from "./pages/admin/RolePermissionPage";
import DepartmentPage from "./pages/admin/DepartmentPage";
import FunderPage from "./pages/admin/FunderPage";
import MenuPage from "./pages/admin/MenuPage";
import ProjectUploadPage from "./pages/admin/ProjectUploadPage";
import ProjectManagementPage from "./pages/admin/ProjectManagementPage";
import CenterManagementPage from "./pages/admin/CenterManagementPage";
import TrainerManagementPage from "./pages/admin/TrainerManagementPage";
import TrainerMasterPage from "./pages/admin/TrainerMasterPage";
import CenterBatchManagementPage from "./pages/admin/CenterBatchManagementPage";
import BatchTrainerManagementPage from "./pages/admin/BatchTrainerManagementPage";
import CourseTrainerManagementPage from "./pages/admin/CourseTrainerManagementPage";
import ProjectCenterManagementPage from "./pages/admin/ProjectCenterManagementPage";
import CenterAssessorManagementPage from "./pages/admin/CenterAssessorManagementPage";
import BulkDeletePage from "./pages/admin/BulkDeletePage";
import BulkUpdatePage from "./pages/admin/BulkUpdatePage";
import HomePage from "./pages/HomePage";
import ViewerLoginPage from "./pages/ViewerLoginPage";
import ViewerPrivateRoute from "./routes/ViewerPrivateRoute";
import AssessorManagementPage from "./pages/admin/AssessorManagementPage";
import CourseManagementPage from "./pages/admin/CourseManagementPage";
import BatchManagementPage from "./pages/admin/BatchManagementPage";
import AttendanceManagementPage from "./pages/admin/AttendanceManagementPage";
import MobilizationManagementPage from "./pages/admin/MobilizationManagementPage";
import FrappeLoginPage from "./pages/FrappeLoginPage";
import AttendancePage from "./pages/AttendancePage";
import CandidateRetention from "./pages/Center/CandidateRetention";
import Certificate from "./pages/Center/Certificate";
import ExternalAssessment from "./pages/Center/ExternalAssessment";
import InternalAssessment from "./pages/Center/InternalAssessment";
import Placement from "./pages/Center/Placement";
import ProjectFilterPage from "./pages/Center/ProjectFilterPage";
import TrainingCompletion from "./pages/Center/TrainingCompletion";
import OtherActivities from "./pages/Center/OtherActivities";
import HealthCamp from "./pages/Center/HealthCamp";
import JiobpHealthcampFeedback from "./pages/Center/JiobpHealthcampFeedback";
import JiobpTrainingFeedbackCalls from "./pages/Center/JiobpTrainingFeedbackCalls";
import PlacedImpactAssessment from "./pages/Center/PlacedImpactAssessment";
import EDPBusinessSetup from "./pages/Center/EDPBusinessSetup";
import MenuPages from "./pages/MenuPages";
import EnrollmentVerificationPage from "./pages/admin/EnrollmentVerification";
import CandidatePage from "./pages/admin/Candidates";
import CreateUserPage from "./pages/admin/CreateUserPage";
import UserMappingPage from "./pages/admin/UserMappingPage";
import ChooseContext from "./pages/dashboard/ChooseContext";
import AdminChooseContext from "./pages/dashboard/AdminChooseContext";
import CenterManagerDashboard from "./pages/dashboard/CenterManagerDashboard";
import FunderDashboard from "./pages/dashboard/FunderDashboard";
import ProjectCoordinatorDashboard from "./pages/dashboard/ProjectCoordinatorDashboard";
import ProjectManagerDashboard from "./pages/dashboard/ProjectManagerDashboard";
import ChatBot from "./pages/ChatBot";
import OrganisationImpactPage from "./pages/dashboard/OrganisationImpactPage";
import YouthSkillingPage from "./pages/dashboard/YouthSkillingPage";
import UpskillingInformalPage from "./pages/dashboard/UpskillingInformalPage";
import WomenEntrepreneurshipPage from "./pages/dashboard/WomenEntrepreneurshipPage";
import CommunityDevelopmentPage from "./pages/dashboard/CommunityDevelopmentPage";
import PreventiveHealthPage from "./pages/dashboard/PreventiveHealthPage";
import PrePostScorePage from "./pages/admin/PrePostScorePage";



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RedirectToDashboard />} />
        {/* Default login route */}
        {/* Viewer login — no backend, static credentials */}
        <Route path="/impacthub_login" element={<ViewerLoginPage />} />

        {/* Viewer-only routes — protected by viewer_token in localStorage */}
        <Route element={<ViewerPrivateRoute />}>
          <Route path="/home" element={<HomePage />} />
          <Route path="/organisation_impact" element={<OrganisationImpactPage />} />
          <Route path="/youth_skilling" element={<YouthSkillingPage />} />
          <Route path="/upskilling_informal" element={<UpskillingInformalPage />} />
          <Route path="/women_entrepreneurship" element={<WomenEntrepreneurshipPage />} />
          <Route path="/community_development" element={<CommunityDevelopmentPage />} />
          <Route path="/preventive_health" element={<PreventiveHealthPage />} />
        </Route>

        <Route path="/login" element={<LoginPage />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/choosecontext" element={<ChooseContext />} />
        <Route path="/admin/choosecontext" element={<AdminChooseContext />} />
        <Route path="/chatbot_page" element={<ChatBot />} />

        <Route element={<PrivateRoute />}>
          <Route element={<MainLayout />}>

            {/* Public dashboard for all logged-in users */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/centermanagerdashboard" element={<CenterManagerDashboard />} />
            <Route path="/projectmanagerdashboard" element={<ProjectManagerDashboard />} />
            <Route path="/projectcoordinatordashboard" element={<ProjectCoordinatorDashboard />} />
            <Route path="/funderdashboard" element={<FunderDashboard />} />
            <Route path="/organisation_impact" element={<OrganisationImpactPage />} />


            <Route path="/admin/permissions" element={<RolePermissionPage />} />



            <Route path="/createuser" element={<CreateUserPage />} />
            <Route path="/user_mappings" element={<UserMappingPage />} />
            <Route path="/departments" element={<DepartmentPage />} />
            <Route path="/funders" element={<FunderPage />} />
            <Route path="/menus" element={<MenuPage />} />
            <Route path="/projects/upload" element={<ProjectUploadPage />} />
            <Route path="/projects_manage" element={<ProjectManagementPage />} />
            <Route path="/centers_manage" element={<CenterManagementPage />} />
            <Route path="/trainer_management" element={<TrainerManagementPage />} />
            <Route path="/trainer_master" element={<TrainerMasterPage />} />
            <Route path="/center_batch_management" element={<CenterBatchManagementPage />} />
            <Route path="/batch_trainer_management" element={<BatchTrainerManagementPage />} />
            <Route path="/course_trainer_management" element={<CourseTrainerManagementPage />} />
            <Route path="/project_center_management" element={<ProjectCenterManagementPage />} />
            <Route path="/center_assessor_management" element={<CenterAssessorManagementPage />} />
            <Route path="/bulk_delete" element={<BulkDeletePage />} />
            <Route path="/bulk_update" element={<BulkUpdatePage />} />
            <Route path="/assessor_management" element={<AssessorManagementPage />} />
            <Route path="/course_management" element={<CourseManagementPage />} />
            <Route path="/batch_management" element={<BatchManagementPage />} />
            <Route path="/attendance_management" element={<AttendanceManagementPage />} />
            <Route path="/mobilization_management" element={<MobilizationManagementPage />} />
            <Route path="/pre_post_scores" element={<PrePostScorePage />} />
            <Route path="/enrollment_verification" element={<EnrollmentVerificationPage />} />
            <Route path="/candidates" element={<CandidatePage />} />
            <Route path="/FrappeLoginPage" element={<FrappeLoginPage />} />
            <Route path="/AttendancePage" element={<AttendancePage />} />
            <Route path="/menupages" element={<MenuPages />} />


            {/* ===========Centers========== */}
            <Route path="/projects_page" element={<ProjectFilterPage />} />
            <Route path="/other_activities" element={<OtherActivities />} />
            <Route path="/internal_assessments" element={<InternalAssessment />} />
            <Route path="/external_assessments" element={<ExternalAssessment />} />
            <Route path="/training_completions" element={<TrainingCompletion />} />
            <Route path="/certificates" element={<Certificate />} />
            <Route path="/placements" element={<Placement />} />
            <Route path="/candidate_retentions" element={<CandidateRetention />} />
            <Route path="/jiobp_healthcamp_feedback" element={<JiobpHealthcampFeedback />} />
            <Route path="/jiobp_training_feedback_calls" element={<JiobpTrainingFeedbackCalls />} />
            <Route path="/placed_impact_assessment" element={<PlacedImpactAssessment />} />
            <Route path="/health_camp" element={<HealthCamp />} />
            <Route path="/edp_business_setup" element={<EDPBusinessSetup />} />

          </Route>
        </Route>


        {/* 404 fallback */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
export default App;



// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import LoginPage from "./pages/LoginPage";
// import Dashboard from "./pages/Dashboard";
// import ErrorPage from "./pages/ErrorPage";
// import NotFound from "./pages/NotFound";
// import PrivateRoute from "./routes/PrivateRoute";
// import MainLayout from "./layouts/MainLayout";
// import AddProjectPage from "./pages/AddProjectPage";
// import ProfilePage from "./pages/ProfilePage";

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Public Routes */}
//         <Route path="/login" element={<LoginPage />} />
//         <Route path="/error" element={<ErrorPage />} />

//         {/* Private Route for Full Page Profile */}
//         <Route path="/profile" element={<PrivateRoute />}>
//           <Route path="" element={<ProfilePage />} />
//         </Route>

//         {/* Private Routes with MainLayout */}
//         <Route path="/" element={<PrivateRoute />}>
//           <Route element={<MainLayout />}>
//             <Route path="dashboard" element={<Dashboard />} />
//             <Route path="add-project" element={<AddProjectPage />} />
//             {/* other pages */}
//           </Route>
//         </Route>

//         {/* 404 */}
//         <Route path="*" element={<NotFound />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;


// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import LoginPage from "./pages/LoginPage";
// import Dashboard from "./pages/Dashboard";

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/login" element={<LoginPage />} />
//         <Route path="/dashboard" element={<Dashboard />} />
//         <Route path="*" element={<LoginPage />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
